import React, { useState, useContext, useEffect, useRef } from "react";
import MobileViewGlobal from "../../Views/MobileView";
import { ScreenContext } from "../../../contexts/ScreenContext";
import { ChatContext } from "../../../contexts/ChatContext";
// import { DropdownMobileView } from "./Dropdown.MobileView";
import Link from "next/link";
import { VIEWS } from "../../Views/MobileNavigationViews";
import useElementHeight from "../../hooks/useElementHeight";
import { setCSSVar } from "../../../util/colorUtil";
import { Modal } from "react-bootstrap";
import ArrowLeftV2 from "../Icons/ArrowLeftV2";
import HomeIconV2 from "../Icons/HomeIconV2";
import AgendaIconPurple from "../Icons/AgendaIconPurple";
import UserPlusIcon from "../Icons/UserPlusIcon";
import UsersIcon from "../Icons/UsersIcon";

export default function NavigationMobileView({
  eventData,
  getHomepageHref,
  handleOnBackClick,
  isBackButtonDisabled,
}) {
  const { inMobileView, setinMobileView, isActiveBurger, setisActiveBurger } =
    useContext(ScreenContext);
  const { unreadMessages, hasUnreadMessages } = useContext(ChatContext);
  const [isActive, setisActive] = useState("");
  const [indicatorBounce, setIndicatorBounce] = useState(false);
  const [total, setTotal] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [navFixedClass, setNavFixedClass] = useState("");
  const navRef = useRef(null);
  const [navHeight, recomputeHeight] = useElementHeight(navRef, [
    isActiveBurger,
  ]);
  const [showModal, setShowModal] = useState(false);

  const toggle = () => {
    setShowModal(!showModal)
  }

  const navItems = {
    back: [<ArrowLeftV2 />],
    home: [<HomeIconV2 />],
    agenda: [<AgendaIconPurple />],
    addUser: [<UserPlusIcon />],
    users: [<UsersIcon />],
  };

  const handleMobileBack = () => {
    if (inMobileView) {
      if (inMobileView === VIEWS.chatMessList)
        setinMobileView(VIEWS.chatAddList);
      if (inMobileView === VIEWS.chatAddList) setinMobileView(VIEWS.home);
      if (inMobileView === VIEWS.home) handleOnBackClick();
    }
  };

  const handleViewClick = (view) => {
    setinMobileView(view);
  };

  const updateScrollY = (e) => {
    setScrollY(window.scrollY);
  };

  const setNavBarPosition = () => {
    if (scrollY > 90) {
      setIsNavFixed(true);
      setNavFixedClass("mobile-nav--slide-in");
    } else {
      setIsNavFixed(false);
      setNavFixedClass("");
    }
  };

  const totalMessageCount = (messages) => {
    let total = 0;
    Object.values(messages).map((item) => {
      total += item;
    });

    setTotal(total);
  };

  const renderItem = (index, navItemName, icon, openModal = false) => {
    const isChatDisabled =
      (navItemName === VIEWS.chatMessList ||
        navItemName === VIEWS.chatAddList) &&
      !eventData?.hasEventUserList;

    if (isChatDisabled) {
      return;
    }

    return (
      <li
        key={index}
        className={
          isActive === navItemName ? "item-active" : "mobile-nav__links-item"
        }
      >
        <button
          onClick={() => {
            if (openModal) {
              setShowModal(true);
              return;
            }
            setisActive(navItemName);

            if (index === 0) {
              handleMobileBack();
            } else {
              handleViewClick(navItemName);
            }
          }}
          tabindex="0"
        >
          {index != 0 ? (
            icon
          ) : (
            <div
              style={{
                opacity:
                  isBackButtonDisabled && inMobileView === "home" ? "0.2" : "1",
              }}
            >
              {icon}
            </div>
          )}
        </button>
        {hasUnreadMessages && index == 3 && (
          <div className="nav-unread">
            <div
              className={
                !indicatorBounce
                  ? `nav-unread--dot`
                  : `nav-unread--dot nav-unread--bouncy`
              }
            >
              <span>{total}</span>
            </div>
          </div>
        )}
      </li>
    );
  };

  useEffect(() => {
    if (typeof navHeight === "number")
      setCSSVar("nav-height", `calc(${navHeight}px)`);
  }, [navHeight]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      recomputeHeight();
    }, 300);

    return () => clearTimeout(timeout);
  }, [isActiveBurger]);

  useEffect(() => {
    totalMessageCount(unreadMessages);
    setIndicatorBounce((prev) => !prev);
    setTimeout(() => {
      setIndicatorBounce((prev) => !prev);
    }, 250);
  }, [hasUnreadMessages, unreadMessages]);

  useEffect(() => {
    setisActive(inMobileView);
  }, [inMobileView]);

  useEffect(() => {
    window.addEventListener("scroll", updateScrollY, false);
    setNavBarPosition();
    return () => {
      window.removeEventListener("scroll", updateScrollY);
    };
  }, [scrollY]);

  return (
    <MobileViewGlobal>
      <div
        style={{ position: `${isNavFixed ? "fixed" : "relative"}` }}
        className={`mobile-nav ${
          isActiveBurger ? "mobile-nav--active" : ""
        } ${navFixedClass}`}
        ref={navRef}
      >
        {/* <div
          className={`mobile-nav__top ${
            isActiveBurger ? "mobile-nav__top--active" : ""
          }`}
        >
          <div className="mobile-nav__top-logo">
            <img src="/assets/vvenuesLogoWhite.svg" />
          </div>
          <div
            className="mobile-nav__top-burger"
            onClick={() => setisActiveBurger((prev) => !prev)}
          >
            <div
              className={`v-burger ${isActiveBurger ? "is-active" : ""}`}
              id="v-burger"
            >
              <span className="line"></span>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </div>
        </div> */}

        {/* <DropdownMobileView isActiveBurger={isActiveBurger} /> */}

        <ul className="mobile-nav__links-wrapp">
          {Object.entries(navItems).map((item, index) => {
            const navItemName = item[0];
            const icon = item[1][0];
            const func = item[1][1];

            if (index == 1) {
              return (
                <>
                  <Link
                    href={getHomepageHref()}
                    as={eventData && eventData.homepageUrl}
                  >
                    {renderItem(index, navItemName, icon)}
                  </Link>
                </>
              );
            }
            if (index == 2) {
              if (!eventData?.hasAgenda) return <></>
              return (
                <>
                  {index != 1 && (
                    <>{renderItem(index, navItemName, icon, true)}</>
                  )}
                </>
              );
            }
            return (
              <>{index != 1 && <>{renderItem(index, navItemName, icon)}</>}</>
            );
          })}
        </ul>
      </div>
      <Modal
        centered
        show={showModal}
        onHide={toggle}
        className="break-sizing modal-action-point-mobile"
      >
        <div className="modal-custom">
          <div
            onClick={toggle}
            className="modal-custom__close"
          >
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div>
            {eventData && eventData.agendaContent && (
              <div
                className="modal-actionpoint-container"
                dangerouslySetInnerHTML={{
                  __html: eventData.agendaContent,
                }}
              />
            )}
          </div>
        </div>
      </Modal>
    </MobileViewGlobal>
  );
}
